<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-autocomplete hide-details label="Tipe" color="primary" :items="type" item-text="text" item-value="value" v-model="typeSelected"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="startDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Dari Tanggal" readonly v-bind="attrs" v-on="on" :value="convertDate(dateStart)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="startDate = false" v-model="dateStart"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="endDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Sampai Tanggal" readonly v-bind="attrs" v-on="on" :value="convertDate(dateEnd)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="endDate = false" v-model="dateEnd"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small v-if="false">mdi-magnify</v-icon>
						<span>Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			startDate: false,
			endDate: false,
			dateStart: new Date().toISOString().slice(0, 10),
			dateEnd: new Date().toISOString().slice(0, 10),
			btnLoadingProses: false,
			type: [
			{ text: 'Semua', value: 'all' },
			{ text: 'Masuk', value: 'in' },
			{ text: 'Keluar', value: 'out' },
			],
			typeSelected: '',
			params: {
				date: {
					type:'date',
					comparison: 'bet',
					field:'ewallet_product_log_datetime',
					value:''
				},
			},
		}
	},
	computed:{

	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.typeSelected = ''
		},
		async cari() {
			if ( this.typeSelected || this.dateStart ) {
				this.params.date.value = this.dateStart + '::' + this.dateEnd
				this.btnLoadingProses = await true
				await this.$emit('action', this.typeSelected, this.params)
			}
		},
	}
};
</script>